
import { Vue, Component, Prop } from "vue-property-decorator";

import Button from "./Button.vue";
import UserMenu from "./UserMenu.vue";
import SolNotification from "~/components/sol/SolNotification.vue";

interface AuthValue {
  user: any;
  loggedIn: boolean;
  logout(): any;
}
@Component({
  components: { Button, UserMenu, SolNotification },
})
export default class Navbar extends Vue {
  @Prop() readonly auth!: AuthValue;
  @Prop({ default: true }) readonly localeSwitcher!: boolean;

  get permissions(): any {
    return this.$store.state.permissions || {};
  }

  get canSwitchOwner(): boolean {
    return !!this.permissions.canSwitchOwner;
  }

  get ownersList(): any {
    return this.$store.state.owners.items.map((owner: any) => {
      if (owner.name) {
        return {
          code: owner.uid,
          label: `${owner.uid} (${owner.name})`,
        };
      } else {
        return {
          code: owner.uid,
          label: owner.uid,
        };
      }
    });
  }

  get currentOwner(): any {
    const curr = this.$store.state.currentOwner;
    return this.ownersList.find((owner: any) => owner.code === curr);
  }

  onSelectOwner(owner: any): void {
    const value = owner.code;
    this.$store.commit("setOwner", value);
    this.$store.commit("loadUsernames", null);
    this.$socket.changeOwner(value);
    localStorage.setItem("currentOwner", value);
    location.reload();
  }

  toggleSidebar(): void {
    this.$store.commit("toggleSidebar");
  }
}
